module.exports = __webpack_public_path__ + "static/img/gorilla.988cb43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gorilla.svg
// module id = OfIM
// module chunks = 1